// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".lg-fullscreen.lg-icon {\n  border: none;\n  background: none;\n}\n", "",{"version":3,"sources":["webpack://src/app/directives/light-gallery/style.styl"],"names":[],"mappings":"AAAA;EACE,YAAQ;EACR,gBAAY;AACd","sourcesContent":[".lg-fullscreen.lg-icon {\n  border: none;\n  background: none;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
